import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { EMPTY_FRAGMENTS } from '../../feature-player/constants/skin';

import { useEpisodeOtt } from './use-episode-ott';

export function useSkippableFragments(contentId: string): SkippableFragment[] {
    const ott = useEpisodeOtt(contentId);

    return (ott?.onlineStreams?.streams?.[0]?.streamMeta?.skippableFragments?.filter(Boolean) ||
        EMPTY_FRAGMENTS) as SkippableFragment[];
}
